import React, { useCallback } from 'react';

import cn from 'classnames';

import { Col, PersonAvatar, Row, Tag } from '@shared/components';

import styles from '../MoveUsersList.less';

type Props = {
  isAdult: boolean;
  gender?: string;
  onSelect: (userId: number) => void;
  personName: string;
  selectIcon: React.ReactNode;
  userId: number;
  className?: string;
};

const MoveUserPerson: React.FC<Props> = ({
  className,
  isAdult,
  gender,
  personName,
  onSelect,
  selectIcon,
  userId,
}) => {
  const handleOnSelect = useCallback(() => {
    onSelect(userId);
  }, [userId, onSelect]);
  return (
    <Tag
      outline={false}
      className={cn(styles.userTag, className)}
      onClick={handleOnSelect}
    >
      <Row type="flex" align="middle">
        <Col>
          <PersonAvatar
            className={styles.userIcon}
            isAdult={isAdult}
            gender={gender}
          />
        </Col>
        <Col>{personName}</Col>
        <Col>
          <div className={styles.addIcon}>{selectIcon}</div>
        </Col>
      </Row>
    </Tag>
  );
};

export default MoveUserPerson;
